import styled from 'styled-components'

import { TransactionListItemPrices } from './transaction-list-item-prices'
import { TransactionListItemStatus } from './transaction-list-item-status'
import { TransactionListItemType } from './transaction-list-item-type'
import { TransactionListItemWallet } from './transaction-list-item-wallet'

import type { Transaction } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

export type TransactionListItemVariant = 'square' | 'row'

type TransactionListItemProps = {
  tx: Transaction.Transaction
  onClick?: (tx: Transaction.Transaction) => void
  withWallet?: boolean
  variant?: TransactionListItemVariant
} & ClassNameProps

const ICON_SIZE = 26

export const TransactionListItem: React.FC<TransactionListItemProps> = ({
  tx,
  onClick,
  className,
  withWallet = false,
  variant = 'row',
}) => {
  const handleClick = () => onClick?.(tx)

  if (variant === 'square') {
    // TODO: Ivan - update styles when design is ready
    return (
      <Root onClick={handleClick} className={className} data-variant={variant}>
        <Header>
          <TransactionListItemType transactionType={tx.type} variant="square" />
          <TransactionListItemWallet tx={tx} variant="square" />
        </Header>
        <TransactionListItemPrices
          tx={tx}
          iconSize={ICON_SIZE}
          variant="square"
        />
        <TransactionListItemStatus tx={tx} variant="square" />
      </Root>
    )
  }

  return (
    <Root onClick={handleClick} className={className}>
      {withWallet ? (
        <PricesGroup>
          <WalletGroup>
            <TransactionListItemWallet tx={tx} variant="row" />
            <TransactionListItemType transactionType={tx.type} variant="row" />
          </WalletGroup>
          <TransactionListItemPrices
            tx={tx}
            iconSize={ICON_SIZE}
            variant="row"
          />
        </PricesGroup>
      ) : (
        <TransactionListItemPrices tx={tx} iconSize={ICON_SIZE} variant="row" />
      )}
      <TransactionListItemStatus tx={tx} variant="row" />
    </Root>
  )
}

const Root = styled.div`
  --tx-background-color: var(--appearanceA-5);
  --tx-background-color-hover: var(--background-2);
  --tx-separator-color: var(--background-2);
  --tx-separator-color-hover: var(--background-3);

  background: var(--tx-background-color);

  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  position: relative;

  display: grid;
  gap: 8px;
  padding: 10px 8px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: var(--tx-background-color-hover);
  }

  &[data-variant='square'] {
    gap: 6px;
  }
`

const WalletGroup = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  align-content: start;
  align-items: start;
`

const PricesGroup = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1fr;
`

const Header = styled.div`
  margin-bottom: 2px;
`
